export class ForwardMessageToDeskActionSettings {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
}
